import { Flex, createStyles, Text, Loader, LoadingOverlay } from "@mantine/core";
import { useRequest } from "ahooks";
import { useState } from "react";
import { NOTIFICATION_SERVICE } from "../../../components/notifications/NotificationService";
import { useStore } from "../../../hooks/use-store";
import { Widget } from "@uploadcare/react-widget";

const useStyles = createStyles((theme) => ({
    main: {
        "> div > button": {
            fontSize: '16px !important',
            // textAlign: 'center',
            // width: '100%',
            fontWeight: '600 !important',
            height: '2.25rem',
            // paddingLeft: '1.125rem',
            // paddingRight: '1.125rem',
            borderRadius: '0.25rem',
            border: 'none',
            color: '#f53c02 !important',
            textDecoration: 'underline !important',
            backgroundColor: 'transparent !important',
            fontFamily: 'Mulish',
        }
    },
}));
export const UploadCarHDRButton = (model: {
    onSetImage: (url: string) => void,
    text ?: string
}) => {

    const { classes } = useStyles();


    const [loading, setLoading] = useState<boolean>(false)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [localImage, setLocalImage] = useState<string | null>(null)
    const {
        dataStore: { appStore },
    } = useStore();

    const { runAsync: runAsyncConvert } = useRequest(
        async (model: { url: string, removeBackground?: boolean }) => appStore.convertImage(model),
        {
            manual: true,
            onSuccess: (res) => {
                if (res.error) {
                    NOTIFICATION_SERVICE.errorNotification(
                        "Sorry, service is unavailable due to high demand. Please try later"
                    );
                } else {
                    return res.url
                }
            },
        }
    );
    return (
        <Flex direction={'column'}>
            <LoadingOverlay visible={loading} loaderProps={{ children: <Flex gap={8}><Loader color="orange" /><Text>Loading...</Text></Flex> }} />
            <Flex w="100%" className={classes.main}>
                        <Widget
                            // imagesOnly
                            localeTranslations={{
                                buttons: {
                                    choose: {
                                        images: {
                                            one: model.text || 'Upload car perspective'
                                        },
                                    },
                                },
                            }}
                            clearable={true}
                            // @ts-ignore
                            onChange={async (info: {
                                crop?: {
                                    width: number
                                    height: number
                                },
                                cdnUrl: string,
                                originalImageInfo: {
                                    width: number
                                    height: number
                                }
                            }) => {

                                setLoading(true)
                                const res = await runAsyncConvert({ url: info.cdnUrl, removeBackground: false })


                                if (res) {
                                    model.onSetImage(res.url)
                                    setLocalImage(info.cdnUrl)
                                    setLoading(false)
                                } else {
                                    NOTIFICATION_SERVICE.errorNotification(
                                        "Sorry, service is unavailable due to high demand. Please try later"
                                    );
                                    setLoading(false)
                                }
                            }}
                            tabs={"file camera url"}
                            publicKey="35626f59762b63c4244c"
                            previewStep={false}
                            
                        />
                    </Flex>


        </Flex>

    )
}